export default __webpack_public_path__ + "static/media/EliasIbnoussima.8675fd0f.png";